import { AbilityBuilder, createMongoAbility, PureAbility } from '@casl/ability';
import { IPermissionCollection } from 'models/permission';

import { Actions, Subjects } from '../types/subjects';

export type AppAbility = PureAbility<[Actions, Subjects]>;

export const defineAbilityFor = (
  permission: IPermissionCollection[],
  isAdmin: boolean
) => {
  const { can, build, rules } = new AbilityBuilder<AppAbility>(
    createMongoAbility
  );

  if (isAdmin) {
    can('manage', 'all');
  } else {
    permission.forEach(({ action, subject }) => {
      can(action as Actions, subject as Subjects);
    });
  }

  return {
    build: build({
      detectSubjectType: (item) =>
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item as any).__caslSubjectType__ || (item as any).constructor?.name,
    }),
    rules,
  };
};
